import getEnv from '@wetransfer/transfer/config/env';

export const extractHostname = (url) => {
  //find & remove protocol (http, ftp, etc.) and get hostname
  const hostname = url.split('/')[2];

  //find & remove port number and "?"
  return hostname.split(':')[0].split('?')[0];
};

export const getDomainWithoutSubdomain = (url) => {
  const urlParts = new URL(url).hostname.split('.');

  return urlParts.slice(urlParts.length === 4 ? -3 : -2).join('.');
};

export const extractRootDomain = (url) => {
  const domain = extractHostname(url);
  const parts = domain.split('.');

  //extracting the root domain here
  return `${parts[parts.length - 2]}.${parts[parts.length - 1]}`;
};

export const getCurrentPathname = () => {
  return window.location.pathname;
};

export const isBetaEnv = () => {
  const env = getEnv();

  return (
    env.NEXT_PUBLIC_SERVER_ENV === 'staging' ||
    env.NEXT_PUBLIC_SERVER_ENV === 'westage'
  );
};

export const isLocalEnv = () =>
  (getEnv().NEXT_PUBLIC_SERVER_ENV === 'local' ||
    process.env.NODE_ENV === 'development') &&
  window.location.hostname.includes('lvh');

export const isTestEnv = () =>
  getEnv().NEXT_PUBLIC_SERVER_ENV === 'test' || process.env.NODE_ENV === 'test';

export const isProductionEnv = () =>
  !isTestEnv() && !isBetaEnv() && !isLocalEnv();

export default {
  extractHostname,
  extractRootDomain,
  getCurrentPathname,
  isBetaEnv,
  isLocalEnv,
  isProductionEnv,
  getDomainWithoutSubdomain,
};
